"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _solarReact = require("@solar/solar-react");

var _ChatImage = _interopRequireDefault(require("./ChatImage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      // ChatOutput parent should always be a Flex column -> fragments?
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch'
    },
    // TODO: move this shit to Solar React:
    messageGroup: {
      maxWidth: '80%'
    },
    messageGroupRight: {
      marginRight: 8
    },
    messageImage: {
      maxHeight: '40vh'
    },
    message: {
      backgroundColor: theme.palette.grey[200],
      '&:not(:last-child)': {
        marginBottom: 2
      }
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary[400],
      color: 'white'
    },
    avatar: {
      width: 32,
      height: 32,
      marginRight: 12,
      marginBottom: 16
    },
    username: {
      paddingLeft: 12,
      marginBottom: 2
    }
  };
});

var MessageGroup = function MessageGroup(_ref) {
  var classes = _ref.classes,
      user = _ref.user,
      right = _ref.right,
      messages = _ref.messages,
      componentMap = _ref.componentMap,
      onImageClick = _ref.onImageClick;

  var map = _objectSpread(_objectSpread({}, componentMap), {}, {
    imgSrc: function imgSrc(_ref2, right) {
      var _id = _ref2._id,
          _imgSrc = _ref2.imgSrc,
          text = _ref2.text;
      return /*#__PURE__*/_react["default"].createElement(_ChatImage["default"], {
        key: _id,
        src: _imgSrc,
        align: right ? 'right' : 'left',
        color: right ? 'primary' : null,
        component: _solarReact.Rounded,
        className: classes.message,
        classes: {
          img: classes.messageImage,
          text: right && classes.colorPrimary
        },
        onClick: function onClick() {
          return onImageClick(_imgSrc);
        }
      }, text);
    },
    text: function text(_ref3, right) {
      var _id = _ref3._id,
          _text = _ref3.text;
      return /*#__PURE__*/_react["default"].createElement(_solarReact.ChatText, {
        key: _id,
        color: right ? 'primary' : null,
        align: right ? 'right' : 'left',
        component: _solarReact.Rounded,
        className: (0, _classnames["default"])(classes.message, right && classes.colorPrimary)
      }, _text);
    }
  });

  var grouped = /*#__PURE__*/_react["default"].createElement(_solarReact.ChatMessageGroup, {
    align: right ? 'right' : 'left',
    className: (0, _classnames["default"])(classes.messageGroup, right ? classes.messageGroupRight : '')
  }, messages.map(function (message) {
    var prop = Object.keys(map).find(function (key) {
      return message[key];
    });

    if (prop) {
      return map[prop](message, right);
    }
  }));

  return right ? grouped : /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    alignItems: "flex-end",
    flexGrow: 1
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    className: classes.avatar,
    src: user.avatarUrl
  }), /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    flexDirection: "column",
    flexGrow: 1
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "caption",
    className: classes.username
  }, user.username), grouped));
};

var Conversation = function Conversation(_ref4) {
  var className = _ref4.className,
      messages = _ref4.messages,
      user = _ref4.user,
      componentMap = _ref4.componentMap,
      onImageClick = _ref4.onImageClick;
  var classes = useStyles(); // group messages per user

  var groups = [];
  var g = null;
  var prevUser = null;
  messages.forEach(function (message) {
    if (prevUser !== message.user._id) {
      // new group
      if (g) {
        groups.push(g);
      }

      g = [];
      prevUser = message.user._id;
    }

    g.push(message);
  });

  if (g) {
    groups.push(g);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, className)
  }, groups.map(function (group) {
    return group[0].user._id === 'system' ? group.map(function (g) {
      return /*#__PURE__*/_react["default"].createElement(_solarReact.ChatDivider, null, g.system);
    }) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: group[0].text
    }, /*#__PURE__*/_react["default"].createElement(_solarReact.ChatDivider, null, group[0].time), /*#__PURE__*/_react["default"].createElement(MessageGroup, {
      classes: classes,
      messages: group,
      user: group[0].user,
      right: group[0].user._id === user,
      componentMap: componentMap,
      onImageClick: onImageClick
    }));
  }));
};

Conversation.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string,
  componentMap: _propTypes["default"].object
};
Conversation.defaultProps = {
  className: ''
}; // prettier-ignore

var _default = Conversation;
exports["default"] = _default;